import { useQuery } from 'data-fetching-client';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import TrackableButton from 'automation-ui-usage-tracking/components/TrackableButton';
import { useHasScope, useWorkflowCountLimit } from 'automation-ui-core/hooks/authHooks';
import LockedUpgradeButton from 'automation-ui-management/components/upgrade-points/LockedUpgradeButton';
import Scopes from 'automation-ui-management/constants/Scopes';
import { GET_WORKFLOW_COUNT_FOR_LIMIT, WORKFLOW_COUNT_FOR_LIMIT_FIELDNAME } from 'automation-ui-management/queries/crmObjectQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const WorkflowLimitsTrackableButton = ({
  onClick,
  trackableKey,
  immediate,
  'data-test-id': dataTestId,
  disabled,
  children,
  size,
  use,
  upgradePoint = 'automation-workflow-limit'
}) => {
  const workflowCountLimit = useWorkflowCountLimit();
  const hasEnterprise = useHasScope(Scopes.WORKFLOWS_ENTERPRISE_LIMITS);
  const {
    data
  } = useQuery(GET_WORKFLOW_COUNT_FOR_LIMIT);
  // TODO (SEE): loading and error states
  const workflowCount = data && data[WORKFLOW_COUNT_FOR_LIMIT_FIELDNAME] || 0;
  const isAtWorkflowLimit = workflowCount >= workflowCountLimit;
  if (isAtWorkflowLimit) {
    if (hasEnterprise) {
      return /*#__PURE__*/_jsx(UITooltip, {
        autoPlacement: true,
        title: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-management.button.accessDisabled.workflowLimit",
          options: {
            workflowsCap: workflowCountLimit
          }
        }),
        children: /*#__PURE__*/_jsx(LockedUpgradeButton, {
          "data-test-id": dataTestId,
          upgradeKey: upgradePoint,
          disabled: disabled,
          size: size,
          use: use,
          children: children
        })
      });
    } else {
      return /*#__PURE__*/_jsx(LockedUpgradeButton, {
        "data-test-id": dataTestId,
        upgradeKey: "workflows-marketing-enterprise",
        size: size,
        use: use,
        children: children
      });
    }
  }
  return /*#__PURE__*/_jsx(TrackableButton, {
    "data-test-id": dataTestId,
    onClick: onClick,
    disabled: disabled,
    trackableKey: trackableKey,
    immediate: immediate,
    size: size,
    use: use,
    children: children
  });
};
export default WorkflowLimitsTrackableButton;